import { render, staticRenderFns } from "./accessRecords.vue?vue&type=template&id=3518ca00&scoped=true&"
import script from "./accessRecords.vue?vue&type=script&lang=js&"
export * from "./accessRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3518ca00",
  null
  
)

export default component.exports